import { render } from "./RecentComments.vue?vue&type=template&id=1c812a10&scoped=true"
import script from "./RecentComments.vue?vue&type=script&lang=js"
export * from "./RecentComments.vue?vue&type=script&lang=js"

import "./RecentComments.vue?vue&type=style&index=0&id=1c812a10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c812a10"]])

export default __exports__